import { render, staticRenderFns } from "./UsersReport.vue?vue&type=template&id=164fd756"
import script from "./UsersReport.vue?vue&type=script&lang=js"
export * from "./UsersReport.vue?vue&type=script&lang=js"
import style0 from "./UsersReport.vue?vue&type=style&index=0&id=164fd756&prod&lang=scss"
import style1 from "./UsersReport.vue?vue&type=style&index=1&id=164fd756&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports